import { UserProviderInfoModel } from "../../../entities";
import { BaseDataRepository } from "../../BaseDataRepository";

export class UserProviderCalendarRepo extends BaseDataRepository<UserProviderInfoModel> {
  protected baseUrl = "provider";

  async getUserProvidersByUserIdAsync(userId?: string): Promise<UserProviderInfoModel[]> {
    const response = await this.client.get(`${this.baseUrl}/user/?=${userId}`);
    return this.handleResponse<UserProviderInfoModel[]>(response)!;
  }
}

export default UserProviderCalendarRepo;
